/**
 * @generated SignedSource<<e8df875e671c11eedce740dcd44534d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "serviceId"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "serviceById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "demo",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mrchntd",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nameUk",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "graphqlSubscriptionServiceByIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "graphqlSubscriptionServiceByIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bf8e586baf815b5c642b4d746fb508ea",
    "id": null,
    "metadata": {},
    "name": "graphqlSubscriptionServiceByIdQuery",
    "operationKind": "query",
    "text": "query graphqlSubscriptionServiceByIdQuery(\n  $serviceId: String\n) {\n  serviceById(id: $serviceId) {\n    id\n    demo\n    mrchntd\n    name\n    nameUk\n  }\n}\n"
  }
};
})();

node.hash = "b403e66b09828d3f7c284bb8e325023a";

module.exports = node;
